import moment from "moment";
import store from "../../redux/store";
import { callAPi } from "./callApi";
import { is_disposition_enabled } from "./helpers";

export function getCrmCustomerName() {
  const {
    auth: { crmCustomer },
  } = store.getState();

  return crmCustomer.name;
}

export const getCustomer = async (customer_number, customerId = null) => {
  if (customer_number) {
    const customer = await getCustomerApi(customer_number, customerId);
    if(customerId && customer.data){
      return customer.data
    }
    if (
      customer &&
      customer.data &&
      customer.data.objects &&
      customer.data.objects.length > 0
    ) {
      return customer.data.objects[0];
    } else {
      return {
        loaded: true,
        id: null,
        name: "Unknown",
        phone_number: customer_number,
      };
    }
  }
  return {
    loaded: true,
    id: null,
    name: "Unknown",
    phone_number: customer_number,
  };
};

export const getCustomerApi = async (phone_number, customerId = null) => {
  const data = {
    limit: 20,
    offset: 0,
    total_pages: 1,
    total_entries: 1,
    phonebook__phonenumbers_set__number__istartswith: phone_number,
  };
  if (customerId) {
    return callAPi(`/newsr/api/v1/customer/${customerId}/`, "GET");
  } else return callAPi("/newsr/api/v1/customer/", "GET", data);
};

export const getAllCustomerApi = async () => {
  const data = {
    limit: 20,
    offset: 0,
  };
  return callAPi("/newsr/api/v1/customer/", "GET", data);
};

export const getCustomerAsValues = (customer) => {
  const phonebook = customer ? customer.phonebook : null;
  const phonenumbers_set =
    phonebook && phonebook.phonenumbers_set ? phonebook.phonenumbers_set : [];

  const values = {
    customer: customer,
    id: customer.id,
    email: phonebook ? phonebook.email : "",
    name: phonebook ? phonebook.name : "",
    number:
      phonenumbers_set && phonenumbers_set.length > 0
        ? phonenumbers_set[0]["number"]
        : "",
    phone:
      phonenumbers_set && phonenumbers_set.length > 0
        ? phonenumbers_set[0]["number"]
        : "",
    company: phonebook ? phonebook.company : "",
    status: customer.status ? customer.status : "",
    followup_notes: null,
    note: customer.last_notes,
    followup_dt: customer.followup_dt ? customer.followup_dt : null,
    phonenumbers_set: phonenumbers_set,
    created_dt: customer.created_dt ? customer.created_dt : null,
    modified_dt: customer.modified_dt ? customer.modified_dt : null,
  };

  return values;
};

export const findAllActivities = (customer) => {
  if (!customer) return [];
  const isDispositionEnabled = is_disposition_enabled();
  if (isDispositionEnabled) {
    if (!customer.disposition_notes_history) return [];
    let activities = {};

    customer.disposition_notes_history.map((entry) => {
      const groupId = moment(entry.datetime).format("DD MMM YYYY");
      let group = activities[groupId];
      if (!group) {
        group = [];
        activities[groupId] = group;
      }

      const activity = {
        time: moment(entry.datetime).format("HH:mm:ss a"),
        disposition:
          entry.disposition && entry.disposition.level1
            ? entry.disposition.level1
            : " -",
        sub_disposition:
          entry.disposition && entry.disposition.level2
            ? entry.disposition.level2
            : " -",
        note:
          entry.disposition && entry.disposition.note
            ? entry.disposition.note
            : "",
      };

      group.push(activity);
    });
    return activities;
  } else {
    let activities = {};
    let rawNotes = customer.notes;
    if (!rawNotes) return activities;
    rawNotes = rawNotes.replaceAll("\\", "");
    try {
      rawNotes = JSON.parse(rawNotes);

      Object.keys(rawNotes)
        .reverse()
        .map((key) => {
          let entryRaw = rawNotes[key];

          let entry = {};
          let idx = entryRaw.indexOf(":");

          if (idx !== -1 && entryRaw.length > idx + 1 + 2) {
            entry.datetime = entryRaw.substring(0, idx + 1 + 2);
            entry.disposition = { note: entryRaw.substring(idx + 3).trim() };
          } else {
            return;
          }

          const groupId = moment(entry.datetime).format("DD MMM YYYY");
          let group = activities[groupId];
          if (!group) {
            group = [];
            activities[groupId] = group;
          }

          const activity = {
            time: moment(entry.datetime).format("HH:mm:ss a"),
            disposition:
              entry.disposition && entry.disposition.level1
                ? entry.disposition.level1
                : " -",
            sub_disposition:
              entry.disposition && entry.disposition.level2
                ? entry.disposition.level2
                : " -",
            note:
              entry.disposition && entry.disposition.note
                ? entry.disposition.note
                : "",
          };

          group.push(activity);
        });

      return activities;
    } catch (e) {
      console.error("crm-ae activities parse error::", e);
      return activities;
    }
  }
};

export const getAllCustomerFollowupsApi = async (params) => {
  const data = {
    limit: 1000,
    offset: 0,
    customer_id: params.customer_id,
  };
  const response = await callAPi(
    "/newsr/api/v1/customer_followup_details/",
    "GET",
    data
  );
  return response;
};
